<template>
    <div class="table-page-wrapper">

      <div v-show="searchStatus" class="search-wrapper">
      <date-format-select @changeDateFormatData="changeDateFormatData($event.dateFormatId)" :isMonthly="true" />
      <el-select v-model="tableParams.subjectId" clearable placeholder="请选择主体"  filterable>
        <el-option v-for="item in subjectList" :label="item.subjectName" :value="item.subjectId"></el-option>
      </el-select>
        <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
        <el-button @click="toQuery" type="primary" >搜索</el-button>
      </div>
      <div class="table-wrapper">
        <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns" :hide="hides"
          style="padding-bottom: 10px;">
          <el-button @click="downExcel('/subjectInfo/down/subject/mat/data/xlsx', '广告主报表', tableParams)" type="warning" size="small">下载
        </el-button>
        </table-column>

        <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        show-summary highlight-current-row  :summary-method="tableSummary"
         ref="report"   size="small"
        class="js-table" style="width: 100%" @sort-change="sortChange" >
        <el-table-column v-if="tableParams.showType === 1 || tableParams.showType === 2 || tableParams.showType === 3"
          prop="timeHour" :label="tableParams.showType === 1 || tableParams.showType === 3 ? '日期' : '时间'" sortable
          align="center" />
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width" :sortable="  v.field === 'reqSmt'
        || v.field === 'resSmt'
        || v.field === 'fillingRate'
        || v.field === 'showSmt'
        || v.field === 'showRat'
        || v.field === 'clkSmt'
        || v.field === 'clickRate'
        || v.field === 'winPrice'
        || v.field === 'channelEcpm'
        || v.field === 'ecpmAverage'
        || v.field === 'auctionPrice'
        || v.field === 'profit'" :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <el-tag v-if="v.field === 'deeplinkNumberProportion' || v.field === 'timeoutNumberProportion'" type="info">
              {{ scope.row[v.field] }}</el-tag>
            <el-tag
              v-else-if="v.field === 'showRat' || v.field === 'clickRate' || v.field === 'dpRate' || v.field === 'bidRate'"
              type="info">{{ scope.row[v.field] }}%</el-tag>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
          :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60,pagination.total]"
          background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
      </div>
    </div>
  </template>

<script>
import DateFormatSelect from './components/DateFormatSelect'
import TableColumn from '@/components/TableColumn'
import { uuid } from '@/util/util'
import { getMasterSubjectInfo } from '@/api/report/dsp'
import BaseDatePicker from '@/components/BaseDatePicker'
import { downExcelMixin } from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'

export default {
  name: 'reportSubject',
  components: {
    DateFormatSelect,
    TableColumn,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      subjectTypeList: { 1: '以我们结算主体', 2: '广告主主体区分' },
      columns: [
        { field: 'subjectName', title: '广告主' },
        { field: 'reqSmt', title: '请求数' },
        { field: 'resSmt', title: '填充数' },
        { field: 'fillingRate', title: '填充率' },
        { field: 'uniShowSmt', title: '展示数' },
        { field: 'showRat', title: '展示率' },
        { field: 'uniClkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'auctionPrice', title: '支出' },
        { field: 'channelEcpm', title: '支出ecpm' },
        { field: 'winPrice', title: '收入' },
        { field: 'ecpmAverage', title: '收入ecpm' },
        { field: 'profit', title: '利润' }
      ],
      hides: [
        'uniWinSmt', 'bidRate', 'cpcPrice', 'effectiveResSmt'
      ],
      listData: [],
      subjectList: [],
      searchDate: {
        startTime: '',
        endTime: ''
      }
    }
  },

  created () {
    this.getSubjectInfo()
  },
  mounted () {
    this.$nextTick(() => {
      this.tableParams.showType = 1
      this.init()
    })
  },
  methods: {
    getSubjectInfo () {
      getMasterSubjectInfo().then(res => {
        this.subjectList = res.data
      })
    },
    changeDate (date) {
      this.searchDate = Object.assign({}, date)
      this.tableParams.startTime = date.startTime + '00'
      this.tableParams.endTime = date.endTime + '23'
    },
    changeDateFormatData (dateFormatId) {
      // this.dateId = dateFormatId
      this.tableParams.showType = null
      if (dateFormatId === 0) {
        this.tableParams.showType = 0
      } else if (dateFormatId === 1) {
        this.tableParams.showType = 1
      } else if (dateFormatId === 2) {
        this.tableParams.showType = 2
      } else {
        this.tableParams.showType = 3
      }
      this.changeDate(this.searchDate)
      this.toQuery()
    },
    beforeInit () {
      this.tableUrl = '/subjectInfo/get/subject/mat/data'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = this.generateTableId(res.data.records, 0)
    },
    upTag (tag) {
      this.tableParams.tag = tag
    },
    sizeChange (e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    toQuery () {
      // if (this.dspSlotIdList) {
      //   this.tableParams.dspSlotIdList = this.dspSlotIdList.join(',')
      // }

      this.init()
    },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    },
    generateTableId (data, base) {
      if (!data) return []
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid()

        if (base === 0) {
          data[i].hasChildren = true
        } else {
          data[i].dspSlotCode = data[i].slotId
          data[i].dspName = data[i].channelName
          data[i].dspSlotName = data[i].slotName
          data[i].dauDspSlotReqSmt = data[i].dauReqSmt
        }
      }
      return data
    },
    tableSummary (row) {
      const arr = [
        'uniShowSmt',
        'uniClkSmt',
        'reqSmt',
        'resSmt',
        'dpSmt',
        'uniWinSmt'
      ]
      const fixedArr = ['auctionPrice', 'winPrice', 'profit']
      const fixed2Arr = [
        'channelEcpm',
        'ecpmAverage',
        'fillingRate',
        'showRat',
        'clickRate',
        'dpRate',
        'bidRate'
      ]
      const { data } = row
      const checklists = this.checkColumns.map((item) => {
        return item.field
      })
      if (this.tableParams.showType > 0) {
        checklists.unshift('0')
      }
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = data
              .reduce((total, item) => {
                return total + Number(item[checklists[i]])
              }, 0)
              .toFixed(4)
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case 'channelEcpm':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.auctionPrice)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  1000
                ).toFixed(4)
                break
              case 'ecpmAverage':
                out[i] = (
                  (data
                    .reduce((total, item) => {
                      return total + Number(item.winPrice)
                    }, 0)
                    .toFixed(4) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  1000
                ).toFixed(2)
                break
              case 'fillingRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.resSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.reqSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'showRat':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniShowSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'clickRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniClkSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'dpRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.dpSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'bidRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniWinSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                  return total + Number(item[checklists[i]])
                }, 0)
                : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

  <style scoped lang="scss">
  .search-wrapper {
    padding: 15px 15px 5px;
    margin-bottom: 10px;
    background: #ffffff;

    &>* {
      margin-right: 15px;
      margin-bottom: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    &>.el-select,
    &>.el-input {
      width: 220px;
    }
  }

  .table-wrapper {
    padding: 15px;
    background: #ffffff;

    .table__operation {
      padding-bottom: 10px;
    }
  }

  .el-pagination {
    text-align: right;
  }

  ::v-deep.el-table__expand-icon {
    width: auto !important;
  }

  ::v-deep.el-table__body-wrapper {
    order: 0;
  }
  </style>
